import { render, staticRenderFns } from "./HeadingWithInfo.vue?vue&type=template&id=2e6a0349&scoped=true"
import script from "./HeadingWithInfo.vue?vue&type=script&lang=js"
export * from "./HeadingWithInfo.vue?vue&type=script&lang=js"
import style0 from "./HeadingWithInfo.vue?vue&type=style&index=0&id=2e6a0349&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a0349",
  null
  
)

export default component.exports